module.exports = __webpack_public_path__ + "img/2010 winteressen 007.cad3fccc.jpg";